module.exports = __webpack_public_path__ + "img/down-arrow-1.ec38e80f.svg";